import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import React, { Component } from 'react'
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl'
import {
    Link,
    Redirect
} from 'react-router-dom'
import ConfirmButton from '../../common/button/confirmbutton.component.jsx'
import TimeZoneSelect from '../../common/date/timezoneselect.component.jsx'
import TaxSelect from '../../common/pricing/taxselect.component.jsx'
import CompanyInputs from '../../customer/companyInputs.component.jsx'
import Integrations from '../../integration/Integrations.jsx'
import LocationEditTabs from './LocationTabsComponent'

class LocationEditForm extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            id: '',
            name: '',
            defaultQuoteTemplateId: '',
            defaultInvoiceTemplateId: '',
            defaultContractTemplateId: '',
            defaultOrderTemplateId: '',
            checkValidForm: false,
            defaultTaxId: '',
            isValidForm: true,
            timeZone: AppContext.getAccount().attributes.timeZone,
            organization: null,
            location: null,
            deleteButton: '',
            externalConfigs: [],
            externalLinks: [],
        }

        this.submit = this.submit.bind(this)
        this.validateLocationForm = this.validateLocationForm.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.remove = this.remove.bind(this)
    }

    componentDidMount() {
        const location = this.props.location
        if (location && location.id) {
            this.loadLocation(location)
        }
        AppContext.getApiClient().get('/external-location-configurations').then(res => {
            this.setState({
                externalConfigs: res.data || [],
            })
        })
    }

    loadLocation(location) {
        const deleteButton = <ConfirmButton identifier={location.attributes.name} onClick={this.remove}
            className='btn btn-danger'>
            <FormattedMessage
                id='location.form.edit.delete_btn'
                defaultMessage='Delete location'
            />
        </ConfirmButton>
        this.setState({
            id: location.id,
            name: location.attributes.name,
            defaultTaxId: location.attributes.defaultTaxId,
            defaultQuoteTemplateId: location.attributes.defaultQuoteTemplateId,
            defaultInvoiceTemplateId: location.attributes.defaultInvoiceTemplateId,
            defaultContractTemplateId: location.attributes.defaultContractTemplateId,
            defaultOrderTemplateId: location.attributes.defaultOrderTemplateId,
            timeZone: location.attributes.timeZone,
            externalLinks: location.attributes.externalLinks.map(l => {
                return {
                    type: l.attributes.type,
                    integrationKey: l.attributes.integrationKey,
                    externalId: l.attributes.externalId,
                }
            }),
            location: location,
            deleteButton: deleteButton,
        })
    }

    remove(event) {
        AppContext.getApiClient().delete('/locations/' + this.state.id).then(response => {
            if (!response.error) {
                this.setState({ formStatus: <Redirect to={{ pathname: '/locations/listing' }} /> })
            }
        })
        event.preventDefault()
    }

    saveLocation() {
        if (this.state.location && this.state.id) {
            let updates = {}
            const allowedFields = [
                'name',
                'defaultTaxId',
                'defaultQuoteTemplateId',
                'defaultInvoiceTemplateId',
                'defaultOrderTemplateId',
                'defaultContractTemplateId',
                'timeZone',
                'externalLinks',
            ]
            for (let i = 0; i < allowedFields.length; i++) {
                let field = allowedFields[i]
                if (this.state.location.attributes[field] != this.state[field]) {
                    updates[field] = this.state[field]
                }
            }
            if (this.state.organization) {
                updates.organization = this.state.organization
            }
            return AppContext.getApiClient().patch('/locations/' + this.state.id, updates)
        } else {
            return AppContext.getApiClient().post('/locations', {
                'name': this.state.name,
                'defaultTaxId': this.state.defaultTaxId,
                'timeZone': this.state.timeZone,
                'organization': this.state.organization,
                'externalLinks': this.state.externalLinks,
            })
        }
    }

    submit(event) {
        event.preventDefault()
        this.setState({
            checkValidForm: true,
        })
        if (!this.validateLocationForm() || !this.state.isValidForm) {
            return
        }
        this.saveLocation().then(response => {
            if (!response.error) {
                this.setState({ formStatus: <Redirect to={{ pathname: '/locations/listing', checkValidForm: false }} /> }, () => {
                    window.location.reload()
                })
            }
        })
        this.setState({
            checkValidForm: false,
        })
        event.preventDefault()
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    setExternalLink(externalId, type, integrationKey) {
        const links = this.state.externalLinks
        const link = links.filter(l => l.type === type && l.integrationKey === integrationKey)[0]
        if (link) {
            this.setState({
                externalLinks: links.map(l => {
                    if (l.type === type && l.integrationKey === integrationKey) {
                        return {
                            type: l.type,
                            integrationKey: l.integrationKey,
                            externalId: externalId,
                        }
                    }
                    return l
                })
            })
        } else {
            links.push({
                type: type,
                integrationKey: integrationKey,
                externalId: externalId,
            })
            this.setState({
                externalLinks: links
            })
        }
    }

    validateLocationForm() {
        let form = document.getElementById("location-form")
        const checkResult = form.checkValidity()
        form.classList.add('was-validated')
        return checkResult
    }

    getExternalLink(type, integrationKey) {
        let link = this.state.externalLinks.filter(l => l.type === type && l.integrationKey === integrationKey)[0]
        if (link) {
            return link
        } else {
            return {
                type: type,
                integrationKey: integrationKey,
                externalId: ''
            }
        }

    }

    render() {
        const messages = defineMessages({
            'name_placeholder': {
                id: 'location.form.edit.name_placeholder',
                defaultMessage: 'Name of the location',
            },
            'save_btn': {
                id: 'location.form.edit.save_btn',
                defaultMessage: 'Save',
            },
            'location.form.edit.none_label': {
                id: 'location.form.edit.none_label',
                defaultMessage: 'None',
            },
        })

        return (
            <>
                <LocationEditTabs locationId={this.state.id} />
                <form className="needs-validation" id="location-form" onSubmit={this.submit} noValidate>
                    <div className='row ui-has-modules'>
                        <div className='col-12 ui-module'>
                            <div className='d-flex'>
                                <div className='flex-fill p-2'>
                                    <label className='form-label' htmlFor='name'>
                                        <FormattedMessage
                                            id='location.form.edit.name_label'
                                            defaultMessage='Name'
                                        />
                                    </label>
                                    <input
                                        name='name'
                                        value={this.state.name}
                                        onChange={this.handleFormChange}
                                        id='name'
                                        type='text'
                                        className='form-control'
                                        placeholder={this.props.intl.formatMessage(messages['name_placeholder'])}
                                    />
                                </div>
                            </div>

                            <CompanyInputs
                                contact={this.state.location?.attributes.organization || null}
                                checkValidForm={this.state.checkValidForm}
                                onChange={org => this.setState({ organization: org })}
                                changeFormIsValid={(isValidForm) => {
                                    this.setState({ isValidForm: isValidForm })
                                }}
                            />

                            <div className='d-flex'>
                                <div className='flex-fill p-2'>
                                    <label className='form-label' htmlFor='lastName'>
                                        <FormattedMessage
                                            id='location.form.edit.time_zone_label'
                                            defaultMessage='Time zone'
                                        />
                                    </label>
                                    <TimeZoneSelect
                                        value={this.state.timeZone}
                                        onChange={zone => {
                                            this.setState({ timeZone: zone })
                                        }}
                                        className='form-control'
                                    />
                                </div>
                            </div>

                            <div className='d-flex'>
                                <div className='flex-fill p-2'>
                                    <label className='form-label' htmlFor='lastName'>
                                        <FormattedMessage
                                            id='location.form.edit.default_tax_label'
                                            defaultMessage='Default tax'
                                        />
                                    </label>
                                    <TaxSelect
                                        value={this.state.defaultTaxId}
                                        onChange={taxId => {
                                            this.setState({ defaultTaxId: taxId })
                                        }}
                                        className='form-control'
                                    />
                                </div>
                            </div>
                            {this.state.externalConfigs.map((conf, key) => {
                                let link = this.getExternalLink(conf.id, conf.attributes.integrationKey)
                                const options = []
                                for (let field in conf.attributes.values) {
                                    options.push(<option key={field} value={field}>
                                        {conf.attributes.values[field]}
                                    </option>)
                                }
                                return <div className='d-flex' key={key}>
                                    <div className='flex-fill p-2'>
                                        <label className='form-label' htmlFor='externalId'>
                                            <FormattedMessage
                                                id='location.form.edit.external_link_label'
                                                defaultMessage='External Link'
                                            />
                                        </label>
                                        <select id={'externalId'} className={'form-control'} value={link.externalId}
                                            onChange={event => {
                                                this.setExternalLink(event.target.value, link.type, link.integrationKey)
                                            }}>
                                            <option value={''}>
                                                {this.props.intl.formatMessage(messages['location.form.edit.none_label'])}
                                            </option>
                                            {options}
                                        </select>
                                        <small className='form-text text-muted'>
                                            {Integrations.getIntegrationNameFromKey(link.integrationKey)}
                                        </small>
                                    </div>
                                </div>
                            })}
                        </div>
                        <div className='col-12'>
                            {this.state.formStatus}
                        </div>
                        <div className='col-12 ui-module'>
                            <div className='row'>
                                <div className='col-6'>
                                    {this.state.deleteButton}
                                </div>
                                <div className='col-6 text-align-right'>
                                    <Link to='/locations/listing' className='btn btn-light'>
                                        <FormattedMessage
                                            id='location.form.edit.cancel_btn'
                                            defaultMessage='Cancel'
                                        />
                                    </Link>
                                    &nbsp;
                                    &nbsp;
                                    <input type='submit' value={this.props.intl.formatMessage(messages['save_btn'])}
                                        className='btn btn-primary' />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </>
        );
    }
}

export default injectIntl(LocationEditForm)


// WEBPACK FOOTER //
// ./src/location/form/edit.component.jsx